import React from 'react';
import { Link } from 'react-router-dom';
import { Home, HeartHandshake, Flower2, Sun, Sprout, Bot } from 'lucide-react';

// Reusable internal-link block — "Solutions selon votre situation"
// Place lightly across the site (Home, Services, key service pages).
const SOLUTIONS = [
  { to: '/jardin-pret-arrivee-vendee', label: 'Jardin prêt avant votre arrivée', icon: Home },
  { to: '/jardinage-senior-vendee', label: 'Aide jardinage pour seniors', icon: HeartHandshake },
  { to: '/entretien-massifs-desherbage-paillage', label: 'Massifs propres & désherbage', icon: Flower2 },
  { to: '/jardin-secheresse-paillage-vendee', label: 'Jardin plus facile en été', icon: Sun },
  { to: '/scarification-entretien-pelouse-vendee', label: 'Rénovation & scarification de pelouse', icon: Sprout },
  { to: '/entretien-pelouse-robot-tondeuse', label: 'Finitions autour robot tondeuse', icon: Bot },
];

export const SolutionsSelonSituation = ({ exclude = null, title = 'Solutions selon votre situation' }) => {
  const items = SOLUTIONS.filter((s) => s.to !== exclude);

  return (
    <div data-testid="solutions-selon-situation">
      <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">{title}</h2>
      <p className="text-gray-600 mb-6 text-sm">
        Chaque jardin a son besoin. Voici les accompagnements les plus demandés autour de Coëx.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((s) => {
          const Icon = s.icon;
          return (
            <Link
              key={s.to}
              to={s.to}
              className="group flex items-center gap-3 bg-white border border-gray-200 rounded-xl p-4 hover:border-emerald-300 hover:shadow-md transition-all"
              data-testid={`solution-link-${s.to.replace(/\//g, '')}`}
            >
              <span className="bg-emerald-100 text-emerald-700 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-200 transition-colors">
                <Icon size={20} />
              </span>
              <span className="font-medium text-gray-900 group-hover:text-emerald-700 transition-colors text-sm leading-snug">
                {s.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SolutionsSelonSituation;
